<div class="container" *ngIf="breadcrumb$ | async as breadcrumb">
  <div class="breadcrumbs">
    <ul class="nav nav-tabs">
      <li *ngFor="let item of breadcrumb; let last = last">
        <a [class.disabled]="!item.active" [routerLink]="item.active ? item.route : null" queryParamsHandling="preserve" routerLinkActive="active">{{
          item.name
        }}</a>
        <span *ngIf="!last">&gt;</span>
      </li>
    </ul>
  </div>
</div>
